import { t } from "i18next";
import * as z from "zod";

import { CUSTOMER_SEGMENTS } from "@/features/shared/api/enums";

/**
 * Transfert par scan d'un QR client (`scan-transfer`).
 * `sourceWalletId` optionnel (multi-portefeuilles uniquement).
 */
export const createScanTransferSchema = () =>
  z.object({
    qrToken: z.string().trim().min(1, { message: t("requiredFieldError") }),
    amount: z
      .number({ invalid_type_error: t("invalidFieldError") })
      .positive({ message: t("invalidFieldError") }),
    sourceWalletId: z
      .string()
      .trim()
      .uuid({ message: t("invalidFieldError") })
      .or(z.literal(""))
      .optional(),
    customerReference: z.string().trim().or(z.literal("")).optional(),
    customerSegment: z.enum(CUSTOMER_SEGMENTS, {
      errorMap: () => ({ message: t("requiredFieldError") }),
    }),
  });

export type ScanTransferFormValues = z.infer<
  ReturnType<typeof createScanTransferSchema>
>;
